// src/config/aboutData.js

export const timeline = [
  { year: "2020", event: "Matrix-180 was founded with a vision to automate smarter" },
  { year: "2021", event: "Launched AI data insights platform" },
  { year: "2022", event: "Partnered with 20+ clients across 3 continents" },
  { year: "2023", event: "Introduced machine learning-based lead scoring tools" },
];

export const achievements = [
  { value: 50, suffix: "+", label: "Projects Delivered" },
  { value: 98, suffix: "%", label: "Client Satisfaction" },
  { value: 5, suffix: "+", label: "Industry Verticals" },
];

export const whyChooseUs = [
  "Fast, scalable automation solutions",
  "Data-driven insights tailored to your business",
  "Reliable and secure architecture",
  "24/7 dedicated support",
];
